import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import imageStyles from './imageStyles';

const Avatar = styled(Icon)`
  ${imageStyles}
`;

export default Avatar;
